export class ErroDaApi {

    constructor(data: Partial<ErroDaApi>) {
        Object.assign(this,data)
    }

    DomainData: any
    Error?: string
    ErrorLevel?:"Error"
    ErrorMessage?: string
    ErrorType?: "DomainLayerException"
    SubType?: "DomainLayerException"
    WarnMessage?: string
}